module.exports = __webpack_public_path__ + "img/RECEIVE_MONEY.6097dd8b.svg";